import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { GEOTAB_DATABASE, GeotabCredentials } from 'src/app/geotab/geotab-utils';

@Injectable({
  providedIn: 'root',
})
export class GeotabApiService {
  constructor(private httpClient: HttpClient, @Optional() @Inject(GEOTAB_DATABASE) private geotabDatabase: string) {}

  public getLoginData(): Observable<any> {
    const { userName = '', sessionId = '', database = '' } = this.getGeotabCredentials();
    return this.httpClient.post('https://my.geotab.com/apiv1', {
      method: 'Get',
      params: {
        typeName: 'User',
        search: {
          name: userName,
        },
        credentials: {
          database: database,
          userName: userName,
          sessionId: sessionId,
        },
      },
    });
  }

  public getGeotabServer(): string {
    return sessionStorage.getItem(`rideview:server:${this.geotabDatabase}`);
  }

  public getGeotabCredentials(): GeotabCredentials {
    return JSON.parse(sessionStorage.getItem(`rideview:credentials:${this.geotabDatabase}`));
  }
}
